import React, { Component } from 'react';
import { comment, uncomment } from './apiPost';
import { isAuthenticated } from '../auth';
import { Link } from 'react-router-dom';

class Comment extends Component {

    state = {
        text: "",
        error: ""
    }


    handleChange = event => {
        this.setState({ text: event.target.value, error: "" });
    }

    isValid = () => {
        const { text } = this.state;
        if (!text.length > 0 || text.length > 150) {
            this.setState({ error: "Comments cannot be empty or more than 150 characters." });
            return false;
        }
        return true;
    }

    addComment = e => {
        e.preventDefault();

        if (!isAuthenticated()) {
            this.setState({ error: "Please signin to leave a comment." });
            return false;
        }

        if (this.isValid()) {
            const userId = isAuthenticated().user._id;
            const token = isAuthenticated().token;
            const postId = this.props.postId;

            comment(userId, token, postId, { text: this.state.text })
                .then(data => {
                    if (data.error) {
                        console.log(data.error);
                    } else {
                        this.setState({ text: '' })
                        // dispatch fresh list of comments to parent control //
                        this.props.updateComments(data.comments);
                    }
                })
        }

    };

    deleteComment = (comment) => {
        const userId = isAuthenticated().user._id;
        const token = isAuthenticated().token;
        const postId = this.props.postId;

        uncomment(userId, token, postId, comment)
            .then(data => {
                if (data.error) {
                    console.log(data.error);
                } else {
                    this.props.updateComments(data.comments);
                }
            })
    }

    deleteConfirmed = (comment) => {
        let answer = window.confirm("Are you sure you want to delete your comment?");
        if (answer) {
            this.deleteComment(comment);
        }
    }

    render() {

        const { comments } = this.props;
        const { error } = this.state;

        return (
            <div className="container">
                <h2 className="mt-5">Leave a Comment</h2>

                <form onSubmit={this.addComment}>
                    <div className="form-group">
                        <input
                            type="text"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.text}
                            placeHolder="Please leave a comment."
                        />
                    </div>
                    <p>
                        <button className="btn btn-raised btn-primary" style={{ float: 'right' }}>
                            Post
                    </button>
                    </p>
                </form>

                <div className="alert alert-danger" style={{ width: '90%', visibility: error ? "visible" : "hidden" }}>
                    {error}
                </div>

                <div className="col">
                    <h3 className="text-primary">{comments.length} Comments</h3>
                    <hr />
                    {comments.map((comment, i) => (
                        <div key={i}>
                            <Link to={`/user/${comment.postedBy._id}`}>
                                <img
                                    className="mr-3 rounded-circle image-thumb"
                                    style={{ height: 50, width: 50, margin: 'auto' }}
                                    src={`${process.env.REACT_APP_API_URL}/user/photo/${comment.postedBy._id}`}
                                    //onError={i => (i.target.src = `${DefaultProfile}`)}
                                    alt={comment.postedBy.name}
                                />

                            </Link>
                            <span style={{ clear: 'both' }}>
                                {comment.text}
                            </span>
                            <p className="font-italic mark mt-2">
                                Posted by: <Link to={`/user/${comment.postedBy._id}`}>{comment.postedBy.name}</Link>
                                {" "}Date: {`${new Date(comment.created).toDateString()} at ${new Date(comment.created).toLocaleTimeString()}`}
                                <span>
                                    {isAuthenticated().user && isAuthenticated().user._id === comment.postedBy._id &&
                                        <>
                                            <a href onClick={() => this.deleteConfirmed(comment)} className="text-danger float-right mr-2" >Remove</a>
                                        </>
                                    }
                                </span>
                            </p>
                        </div>
                    ))}
                </div>



            </div>
        )
    }
}

export default Comment;